import { render } from "./register-stepper-success.vue?vue&type=template&id=5156c147&scoped=true&ts=true"
import script from "./register-stepper-success.vue?vue&type=script&lang=ts"
export * from "./register-stepper-success.vue?vue&type=script&lang=ts"

import "./register-stepper-success.vue?vue&type=style&index=0&id=5156c147&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5156c147"]])

export default __exports__